import { GraduationServicePath } from "utils/constants";

export const graduationRequests = {
  // Thesis defense
  thesisDefenseSessionDate: internshipSessionId =>
    `${GraduationServicePath}thesis-defense/sessions/${internshipSessionId}/date`,
  thesisDefenseRequestAction: (id, action) => `${GraduationServicePath}thesis-defense/${id}/${action}`,

  // Training bases
  cloneTrainingBases: () => `${GraduationServicePath}training-bases/clone`,

  // Plans
  getInternshipPlanForUpdate: id => `${GraduationServicePath}plans/${id}/update`,
  updateInternshipPlan: id => `${GraduationServicePath}plans/${id}`,
  getPlanDisciplinesRequirements: planId => `${GraduationServicePath}plans/${planId}/disciplines/requirements`,

  // Schedules - individual cycles
  assignStudentsToIndividualCycle: cycleId =>
    `${GraduationServicePath}schedules/individual-cycles/${cycleId}/students`,
  removeStudentFromIndividualCycle: (cycleId, studentEducationId) =>
    `${GraduationServicePath}schedules/individual-cycles/${cycleId}/students/${studentEducationId}`,

  // Schedules - individual slots
  getIndividualSlotStudents: slotId => `${GraduationServicePath}schedules/individual/slots/${slotId}/intervals/students`,
  assignIndividualSlotIntervalStudents: () =>
    `${GraduationServicePath}schedules/individual/slots/intervals/students/assignments`,
  removeStudentFromIndividualSlotInterval: (intervalId, studentEducationId) =>
    `${GraduationServicePath}schedules/individual/slots/intervals/${intervalId}/students/${studentEducationId}`,

  // Internship sessions
  getInternshipSession: id => `${GraduationServicePath}internship-sessions/${id}`,
  checkInternshipSessionFinalization: id => `${GraduationServicePath}internship-sessions/${id}/finalization/check`,
  finalizeInternshipSession: id => `${GraduationServicePath}internship-sessions/${id}/finalize`,

  // State exams
  getStateExamResults: id => `${GraduationServicePath}state-exams/${id}/results`,
  stateExamStudentResult: (stateExamId, studentEducationId) =>
    `${GraduationServicePath}state-exams/${stateExamId}/results/${studentEducationId}`,
  updateStateExamCommission: id => `${GraduationServicePath}state-exams/${id}/commission`,
  updateStateExamSlot: id => `${GraduationServicePath}state-exams/${id}/slot`,
  updateStateExamStudyGroups: id => `${GraduationServicePath}state-exams/${id}/study-groups`,

  // Students - internship lifecycle
  getInternshipStudentStatus: educationId => `${GraduationServicePath}students/${educationId}/status`,
  getInternshipStudentStatusHistory: educationId => `${GraduationServicePath}students/${educationId}/status-history`,
  startInternshipForStudent: educationId => `${GraduationServicePath}students/${educationId}/start-internship`,

  // Students - training bases (GET + PUT)
  studentTrainingBases: educationId => `${GraduationServicePath}students/${educationId}/training-bases`,
  deleteStudentTrainingBase: (educationId, trainingBaseId) =>
    `${GraduationServicePath}students/${educationId}/training-bases/${trainingBaseId}`,
  getStudentTrainingBasesSelect: educationId =>
    `${GraduationServicePath}students/${educationId}/training-bases/select`,

  // Students - disciplines requirements (GET + PUT)
  studentDisciplinesRequirements: educationId =>
    `${GraduationServicePath}students/${educationId}/disciplines/requirements`,
  getStudentRequirementHistory: (educationId, requirementId) =>
    `${GraduationServicePath}students/${educationId}/disciplines/requirements/${requirementId}/history`,

  // Students - monthly internship
  getStudentMonthlyInternship: educationId => `${GraduationServicePath}students/${educationId}/monthly-internship`,
  startStudentMonthlyInternship: educationId =>
    `${GraduationServicePath}students/${educationId}/monthly-internship/start`,
  getStudentMonthlyInternshipAttestations: educationId =>
    `${GraduationServicePath}students/${educationId}/monthly-internship/attestations`,
  deleteStudentMonthlyInternshipAttestation: (educationId, attestationId) =>
    `${GraduationServicePath}students/${educationId}/monthly-internship/attestations/${attestationId}`,

  // Selects
  getInternshipSessionTypesSelect: () => `${GraduationServicePath}selects/internshipSessionType`,
  getPlanExamTypesSelect: () => `${GraduationServicePath}selects/planExamType`,
  getPlanScheduleTypesSelect: () => `${GraduationServicePath}selects/planScheduleType`,
  getStateExamsStatusesSelect: () => `${GraduationServicePath}selects/StateExamResultStatus`,
  getThesisDefenseRequestStatusesSelect: () => `${GraduationServicePath}selects/ThesisDefenseRequestStatus`,
  getInternshipSessionsSelect: () => `${GraduationServicePath}internship-sessions/select`,
  getInternshipPlansSelect: () => `${GraduationServicePath}plans/select`,
  getScheduleDateTypeSelect: () => `${GraduationServicePath}selects/scheduleDateType`,
  getInternshipStudentsSelect: () => `${GraduationServicePath}students/select`,
  getStudentMonthlyInternshipLocationTypesSelect: () =>
    `${GraduationServicePath}selects/StudentMonthlyInternshipLocationType`,
  getPlanDisciplinesSelect: planId => `${GraduationServicePath}plans/${planId}/disciplines/select`,
};
